import React, { useEffect, useRef, useState } from "react";
import Styles from "../../styles/gym/creategym.module.scss";
import Navbar from "../../components/Navbar";
import "../../styles/session/quill-custom.css";
import { Link, useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { addGym, getGym, getOptions } from "../../services";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/success.png";
import Copy from "../../assets/gym/copy-01.png";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { toggle } from "../../redux";
import pass_on from "../../assets/auth/pass-on.png";
import { toast, ToastContainer } from "react-toastify";
import pass_off from "../../assets/auth/pass-off.png";
const CreateGym = () => {
  const gymnameRef = useRef();
  const usernameRef = useRef();
  const locationRef = useRef();
  const passwordRef = useRef();
  const phoneRef = useRef();
  const { options } = useSelector((state) => state.exercises);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const navigate = useNavigate();
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };
  useEffect(() => {
    const fetchData = () => {
      getOptions();
    };
    fetchData();
  }, []);
  const handleSubmit = async () => {
    try {
      let phone = phoneRef.current.value.trim();
      const username = usernameRef.current.value.trim();
      const location = locationRef.current.value.trim();

      phone = phone.replace(/[^\d]/g, "").slice(-10);
      if (!/^\d{10}$/.test(phone)) {
        toast.error("Invalid phone number. It must be exactly 10 digits.");

        return;
      }

      if (username !== username.toLowerCase()) {
        toast.error("Username must be in lowercase.");

        return;
      }
      if (!location || location === "") {
        toast.error("Please select a valid location from the list.");

        return;
      }
      const gymdata = {
        name: gymnameRef.current.value,
        location,
        phone,
        username,
        password: passwordRef.current.value,
      };

      const success = await addGym({ ...gymdata });
      if (success) {
        const { username, password } = gymdata;

        Swal.fire({
          html: `
            <div style="text-align: center; border-radius: 16px; position: relative; padding: 10px;">
              <button 
                id="customCloseButton" 
                style="position: absolute; top:-10px; right:-15px; background: none; border: none; cursor: pointer;">
                <img 
                  src=${Close_Button} 
                  alt="Close" 
                  style="width: 32px; height: 32px;"
                />
              </button>
        
              <img 
                src=${Suceess} 
                alt="Success" 
                style="width: 90px; margin-bottom: 15px; margin-top: 20px;" 
              />
        
              <h2 style="color:#151515; text-align:center; font-family:gothambold; font-size:16px;">
                Gym added <br /> successfully
              </h2>
              <p style="color:#2E292A; text-align:center; font-family:gotham_bookregular; line-height:22px; font-size:14px; margin-top: 8px;">
                Save credentials for later
              </p>
        
              <!-- Credentials -->
              <div style="background:transparent; padding: 12px; border:none; border-radius: 6px; margin: 12px auto; width: 92%; text-align: left;">
                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px;">
                  <span style="font-size: 13px; font-family:gotham_bookregular;">Username ID:</span>
                  <strong style="font-size: 13px; color: #f79328; font-family:gotham_bookregular;">${username}</strong>
                  <img 
                    id="copyusername" 
                    src=${Copy} 
                    alt="Copy username" 
                    style="width: 16px; height: 16px; cursor: pointer;" 
                  />
                </div>
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <span style="font-size: 13px; font-family:gotham_bookregular;">Password:</span>
                  <strong style="font-size: 13px; color: #f79328; font-family:gotham_bookregular;">${password}</strong>
                  <img 
                    id="copyPassword" 
                    src=${Copy} 
                    alt="Copy Password" 
                    style="width: 16px; height: 16px; cursor: pointer;" 
                  />
                </div>
              </div>
        
              <!-- Close Button -->
              <button 
                id="closeButton" 
                style="background: transparent; color: #000; padding: 12px 40px; font-size: 13px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 15px; border: 1px solid #E27808; outline: none;">
                Close
              </button>
            </div>
          `,
          showConfirmButton: false,
          allowOutsideClick: false,
          width: "500px",

          customClass: {
            popup: "custom-swal-container",
          },
          didOpen: () => {
            const copyToClipboard = (text, element) => {
              navigator.clipboard
                .writeText(text)
                .then(() => {
                  const swalPopup = Swal.getPopup();
                  if (swalPopup) {
                    const originalText = element.alt;
                    element.alt = "Copied!";
                    element.style.opacity = "0.5";

                    setTimeout(() => {
                      element.alt = originalText;
                      element.style.opacity = "1";
                    }, 1500);
                  }
                })
                .catch(() => {
                  Swal.fire({
                    text: "Failed to copy!",
                    icon: "error",
                    timer: 1500,
                    showConfirmButton: false,
                  });
                });
            };

            const copyUsername = document.getElementById("copyusername");
            const copyPassword = document.getElementById("copyPassword");
            const closeButton = document.getElementById("closeButton");
            const customCloseButton =
              document.getElementById("customCloseButton");

            if (copyUsername) {
              copyUsername.addEventListener("click", (e) => {
                e.stopPropagation();
                copyToClipboard(username, copyUsername);
              });
            }
            if (copyPassword) {
              copyPassword.addEventListener("click", (e) => {
                e.stopPropagation();
                copyToClipboard(password, copyPassword);
              });
            }

            closeButton.addEventListener("click", () => {
              navigate(adminRoutes.listGym);
              window.location.reload();
              Swal.close();
            });
            customCloseButton.addEventListener("click", () => {
              Swal.close();
              navigate(adminRoutes.listGym);
            });
          },
        });
      }
    } catch (error) {
      console.error("Error submitting gym:", error);
    }
  };

  const handleBack = () => {
    navigate(adminRoutes.listGym);
  };
  return (
    <>
      <Navbar />
      <ToastContainer />

      <div
        className={Styles.createsession_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.listGym}>HOME / </Link>{" "}
          <span className={Styles.orange}>Create New Gym</span>
        </h2>

        <div className={Styles.createsession_container}>
          <div className={Styles.createsession}>
            <div className={Styles.createsession_container_heading}>
              <h3>CREATE NEW GYM</h3>
            </div>
            <hr />
            <div className={Styles.createsession_form_container}>
              <form autoComplete="">
                <div className={Styles.createsession_form}>
                  <div className={Styles.createsession_form_containerboxone}>
                    <div
                      className={Styles.createsession_form_containerboxchildone}
                    >
                      <div className={Styles.createsession_form_containerone}>
                        <label className={Styles.label}>Gym Name</label>
                        <input
                          placeholder="Enter here"
                          required
                          type="text"
                          name="gymname"
                          ref={gymnameRef}
                        />
                      </div>

                      <div className={Styles.createsession_form_containertwo}>
                        <div className={Styles.input_group}>
                          <label className={Styles.label}>Locations</label>
                          <select ref={locationRef}>
                            <option value="" disabled selected>
                              Choose from list
                            </option>
                            {options.locations.map((item, index) => (
                              <option key={index} value={item}>
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={Styles.createsession_form_containerright}>
                  <div
                    className={Styles.createsession_form_containerrightchild}
                  >
                    <label className={Styles.label}>Username</label>
                    <input
                      placeholder="Enter here"
                      type="username"
                      name="username"
                      minLength={2}
                      maxLength={50}
                      ref={usernameRef}
                      required
                    />
                  </div>
                  <div
                    className={Styles.createsession_form_containerrightchild}
                  >
                    <label className={Styles.label}>Phone Number</label>
                    <input
                      placeholder="Enter here"
                      type="text"
                      name="phone"
                      ref={phoneRef}
                      maxLength={10}
                      onChange={(e) => {
                        let value = e.target.value.replace(/[^\d]/g, "");
                        if (value.length > 10) {
                          value = value.slice(0, 10);
                        }
                        phoneRef.current.value = value;
                      }}
                      required
                    />
                  </div>
                  <div
                    className={Styles.createsession_form_containerrightchild}
                  >
                    <label className={Styles.label}>Enter Password</label>
                    <input
                      placeholder="Enter here"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      minLength={2}
                      maxLength={50}
                      ref={passwordRef}
                      required
                    />
                  </div>
                  <div
                    type="button"
                    onClick={togglePasswordVisibility}
                    className={Styles.eyeIcon}
                  >
                    <img
                      src={showPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                      className={Styles.eyeImage}
                    />
                  </div>
                </div>
              </form>
            </div>
            <hr />
            <div className={Styles.button_container}>
              <div
                className={Styles.save}
                onClick={handleSubmit}
                style={{ cursor: "pointer" }}
              >
                Save
              </div>
              <div
                className={Styles.cancel}
                onClick={handleBack}
                style={{ cursor: "pointer" }}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateGym;
